import userAuth from './userAuth';

export default {
  namespaced: true,
  modules: {
    auth: userAuth,
  },
  state: {
    isLoading: true,
    details: {
      currencyCode: '',
      city: '',
      country: '',
      creationTime: '',
      email: '',
      language: '',
      optInChannel: 2,
      storageBucket: '',
      stripeCustomerId: '',
    },
  },
  getters: {},
  mutations: {
    RESET_STATE(state) {
      state.isLoading = true;
      state.details = {
        city: '',
        country: '',
        creationTime: '',
        email: '',
        language: '',
        optInChannel: 2,
        storageBucket: '',
        stripeCustomerId: '',
        currencyCode: '',
      };
    },
    SET_IS_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
    SET_DETAILS(state, details) {
      state.details = { ...details };
    },
  },
  actions: {
    resetState({ commit }) {
      commit('RESET_STATE');
    },
    updateDetails({ commit }, details) {
      commit('SET_IS_LOADING', true);

      const userDetails = details;
      if (userDetails.currency) {
        userDetails.currencyCode = userDetails.currency.toLowerCase();
      }
      // Removing deprecated fields
      delete userDetails.currency;
      delete userDetails.billingDetails;
      delete userDetails.subscriptionDetails;

      commit('SET_DETAILS', userDetails);

      commit('SET_IS_LOADING', false);
    },
  },
};
